
const digest = '33a993824aab4c2851156c4c38d7450b534522e5054d3c70cde7f1f68c5858ae';
const classes = {"wrapper":"_wrapper_n8a2q_1"};
const css = `._wrapper_n8a2q_1 {
  font-family: "Rubik", sans-serif;
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  gap: 12px;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  